'use strict';

export {
	default as AuditSalaryAccountReportTable
} from './AuditSalaryAccountReportTable';
export {
	default as AuditSalaryAccountReportWorkplaceTable
} from './AuditSalaryAccountReportWorkplaceTable';
